import React from "react";
import sass from "pages/StepPages/StepFour/One/Tables/TableNavigate/LevelsOfVariantsTable/levels.module.sass";
import NewCheckBox from "components-new/NewCheckBox";

interface IList {
	data: { id: number; name: string }[];
	check: ({ name, id }: { id: number; name: string }, field: string) => void;
	current: any & {
		systemMeans: { id: number; name: string }[] | null;
		tacticTechnic: { id: number; name: string }[] | null;
	};
	field: any;
	lastElement?: React.MutableRefObject<HTMLLabelElement | null>;
}

const List: React.FC<IList> = ({ data, check, current, field, lastElement }) => {
	return (
		<>
			{data.map((_, index) => {
				return (
					<label key={index} className={sass.selectBox_list_wrapper_item}>
						<div className={sass.checkbox}>
							<NewCheckBox
								onChange={() => check(_, field)}
								checked={current[field]! ? !!current[field]!.find((item: any) => item.name === _.name) : false}
								scale={"xs"}
								type={"checkbox"}
							/>
							{_.name}
						</div>
					</label>
				);
			})}
			{lastElement && <label ref={lastElement} />}
		</>
	);
};

export default List;
